import gsap from 'gsap';

export default class HomeHeader {
    constructor() {
        this.delay = 3;

        this.fadeBackground();
        this.titlePosition();
        this.text();
        this.background();
        this.image();
        this.content();

        window.onresize = () => {
            this.titlePosition();
        }
    }

    fadeBackground() {
        const background = document.querySelector('header .text-wrapper .background');
        if (background) {
            gsap.to(
                background,
                {
                    opacity: 0,
                    duration: .7,
                    ease: 'power4.out',
                    delay: this.delay
                }
            );
        }
    }

    titlePosition() {
        const titleWrapper = document.querySelector('header .text-wrapper'),
              textWrapper = document.querySelector('header .content');

        titleWrapper.style.height = (window.innerHeight - document.querySelector('nav').offsetHeight) + 'px';

        gsap.to(
            titleWrapper,
            {
                height: window.innerHeight - textWrapper.offsetHeight - document.querySelector('nav').offsetHeight,
                duration: 1,
                ease: 'power4.out',
                delay: this.delay
            }
        );
    }

    text() {
        gsap.to(
            document.querySelectorAll('header h1 .text-content span'),
            {
                duration: 1.25,
                y: 0,
                x: 0,
                ease: "power4.out",
                stagger: .2
            }
        );

        gsap.to(
            document.querySelector('header a span'),
            {
                duration: 1.25,
                y: 0,
                x: 0,
                ease: "power4.out",
                delay: .6
            }
        );
    }

    background() {
        let viewportHeight = window.innerHeight / 2;

        gsap.to(
            document.querySelector('header figure .background'),
            {
                opacity: 1,
                ease: 'none',
                scrollTrigger: {
                    trigger: 'section#salle',
                    end: `+=${viewportHeight}`,
                    scrub: true
                }
            }
        );
    }

    image() {
        let viewportHeight = window.innerHeight / 1.5;

        gsap.to(
            document.querySelector('header figure img'),
            {
                scale: 1.2,
                ease: 'none',
                scrollTrigger: {
                    trigger: '#salle',
                    end: `+=${viewportHeight}`,
                    scrub: true
                }, 
            }
        );
    }

    content() {
        const contentHeight = document.querySelector('header .content').offsetHeight;

        gsap.to(
            document.querySelector('header .content'),
            {
                duration: 1.25,
                y: 0,
                ease: "power4.out",
                delay: this.delay
            }
        );
    }
}